import React, { Dispatch, ReactNode, RefCallback, SetStateAction, useEffect, useRef } from 'react';
import {
  components,
  GroupBase,
  MenuListProps,
} from 'react-select';

import { Scrollbar } from 'app/design-system/components/Scrollbar';

import styles from '../Dropdown.module.scss';

type Props<T, IsMulti extends boolean, Group extends GroupBase<T>> = {
  children: ReactNode;
  setMenuListBottom?: Dispatch<SetStateAction<number | null>>;
} & MenuListProps<T, IsMulti, Group>;

function MenuList<T, IsMulti extends boolean, Group extends GroupBase<T>>({
  children,
  setMenuListBottom,
  ...props
}: Props<T, IsMulti, Group>): JSX.Element {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (listRef.current && setMenuListBottom) {
      setMenuListBottom(listRef.current.getClientRects()[0].bottom);
    }
  }, [listRef.current]);

  return (
    <components.MenuList {...props}
                         className={styles.menuListCommon}
                         innerRef={listRef as unknown as RefCallback<HTMLDivElement>}>
      <Scrollbar className={styles.scrollContainer}
                 style={{ maxHeight: props.maxHeight }}>
        {children}
      </Scrollbar>
    </components.MenuList>
  );
}

export default MenuList;
